import React from 'react';
import 'react-dropzone-uploader/dist/styles.css';
import Dropzone from 'react-dropzone-uploader';

const ImageDropZone = ({ handleChangeImage }) => {
  const uploadUrl = 'YOUR_UPLOAD_ENDPOINT'; // Replace with your actual endpoint

  // Mock upload params to disable real upload behavior
  const getUploadParams = () => {
    return { url: uploadUrl };
  };

  // Handle change status for uploaded files
  const handleChange = ({ meta, file }, status) => {
    console.log(`File status changed to ${status}`, meta);
    handleChangeImage(file, status);
  };

  return (
    <Dropzone
      maxFiles={1}
      multiple={false}
      inputContent="Thả tệp tin ở đây hoặc nhấp để tải lên"
      getUploadParams={getUploadParams}
      onChangeStatus={handleChange}
      accept="image/*"
      styles={{
        dropzone: {
          border: '1px dashed #d9d9d9',
          backgroundColor: '#f9f9f9',
          borderRadius: '8px',
          textAlign: 'center',
          padding: '20px',
          minHeight: '200px',
          minWidth: '300px'
        },
        dropzoneActive: { borderColor: '#52c41a' },
        inputLabel: {
          color: '#595959',
          fontSize: '14px'
        },
        previewImage: {
          maxHeight: '150px',
          maxWidth: '150px',
          marginTop: '10px'
        }
      }}
      canRestart={false}
      autoUpload={false} // Prevents auto-upload to enable manual handling
    />
  );
};

export default ImageDropZone;
